// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"85d68d0b","175":"6fcf8a70","239":"e39fb35b","455":"d8dbe475","541":"620463e7","605":"75212d59","616":"7d93cd80","711":"e8dd4768","782":"e6f94c01","818":"80150051","820":"f0e2c632","952":"3c7844c3","977":"8591a78c"}[chunkId] + ".chunk.js";
};